import type { ReactNode } from "react";
import { useMemo, useState } from "react";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import {
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import type { Categorie } from "constants/Categories";
import type CommandeArticleHistory from "models/CommandeArticleHistory";
import CommandeHistoryArticle from "./CommandeHistoryArticle";
import { arrayUtil, dateUtil } from "@sdeapps/react-core";

interface CommandeHistoryCategorieProps {
  categorie: Categorie;
  history: Array<CommandeArticleHistory>;
}

function CommandeHistoryCategorie({
  categorie,
  history,
}: Readonly<CommandeHistoryCategorieProps>): ReactNode {
  const [open, setOpen] = useState(false);

  const articleQuantity = useMemo(
    () => history.reduce((previous, current) => previous + current.quantite, 0),
    [history]
  );
  const articleIds = useMemo(
    () => arrayUtil.dedupArray(history.map((value) => value.articleId)),
    [history]
  );

  function handleClick(): void {
    setOpen(!open);
  }

  return history.length > 0 ? (
    <>
      <ListItemButton onClick={handleClick}>
        <ListItemIcon sx={{ minWidth: 40 }}>
          <categorie.icon fontSize="small" />
        </ListItemIcon>
        <ListItemText
          primary={
            <Typography>
              {categorie.printLabel} (<strong>{articleQuantity}</strong>)
            </Typography>
          }
        />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {articleIds.map((value) => {
            const list: Array<CommandeArticleHistory> = (
              history.filter((c) => c.articleId === value) ?? []
            ).toSorted((a, b) => dateUtil.compareDesc(a.dateCommande, b.dateCommande));
            return (
              <CommandeHistoryArticle key={value} article={list[0].articleLabel} history={list} />
            );
          })}
        </List>
      </Collapse>
    </>
  ) : null;
}

export default CommandeHistoryCategorie;
